import React from "react";
import Slider from "react-slick";
import { CarouselImages } from "../assets/carousel";
import { motion } from "framer-motion";
import { AsyncImage } from "loadable-image";
import { Fade } from "transitions-kit";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LazyLoadImage, trackWindowScroll} from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const Home = ({ scrollPosition }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <motion.div
      className="w-full mx-0 overflow-x-hidden overflow-hidden"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.175 }}
    >
      <Slider {...settings}>
        {CarouselImages.map((image, i) => (
          <div key={i}>
            <LazyLoadImage
              src={image.src}
              alt={image.alt}
              effect="blur"
              className=" w-full h-auto"
              scrollPosition={scrollPosition}
              visibleByDefault={i < 3}
            />
          </div>
        ))}
      </Slider>

      {/* Add react-scroll-animation here for profile */}
    </motion.div>
  );
};

export default trackWindowScroll(Home);
